import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from "react";
import { ViewProp, ViewType } from "../interfaces/internal/ViewProps";
import { UserTypes } from "../interfaces/internal/UserType";
import debounce from 'lodash/debounce';

type BladeRefType = { [key: number]: HTMLElement };

interface BladeContextProps {
  blades: ViewProp[];
  addBlade: (blade: ViewProp) => void;
  addBlades: (blade: ViewProp[]) => void;
  removeBlade: (bladeid: number) => void;
  moveBlade: (bladeid: number, left: boolean) => void;
  heightBlade: (bladeid: number, full: boolean | null) => void;
  getHeightBlade: (bladeid: number) => boolean;
  getBlade: (bladeid: number) => ViewProp | null;
  clearBlades: (all: boolean) => void;
  registerRef: (id: number, ref: HTMLElement) => void;
  bladeVisuals: Record<number, { marginLeft: string; marginTop: string }>;
  changeBladesizeAll: (full: boolean) => void;
  organizeBlades: () => void;
  maximizeBlade: (id: number, full: boolean | null) => void;
  maximizeAllBlade: (full: boolean) => void;
  getMaximizeBlade: (id: number) => boolean;
  getNameBlade: (id: number) => string;
  setNameBlade: (id: number, name: string) => void;
  registrateRaceID: (raceid: number) => void;
  setUserType: (user: UserTypes | null) => void;
  getUserType: () => UserTypes | null;
  setAccesToken: (acces: string) => void;
  getAccesToken: string;
  getFocusedBlade: (id: number) => boolean;
  setFocusedBlade: (id: number) => void;
  setClassIDIpos: (id: number, classID: number, ipos: number | null) => void;
  reorderBlades: () => void;
  setMobileMode: (isMobile: boolean) => void;
  getMobileMode: () => boolean;
  raceID: number;
  getAutoIposBlade: (id: number) => void;
  setAutoIposBlade: (id: number, auto: boolean) => void;
  existsBlade: (classid:number,ipos:number) => number | null;
  setHideHamburger: (id:number) => void;
  getHideHamburger: (id:number) => boolean;
}
const bladesFullHeight: ViewType[] = [ViewType.athletebio, ViewType.athletebioTV, ViewType.stage];
const BladesContext = createContext<BladeContextProps | undefined>(undefined);
interface BladeProviderProps {
  children: ReactNode;
}
export const BladeProvider: React.FC<BladeProviderProps> = ({ children }) => {
  const [blades, setBlades] = useState<ViewProp[]>([]);
  const [isMobileMode, setIsMobileMode] = useState<boolean>(false);
  const [bladeVisuals, setBladeVisuals] = useState<
    Record<number, { marginLeft: string; marginTop: string }>
  >({}); // <-- Add this state
  const [bladeElementRefs, setBladeElementRefs] = useState<BladeRefType>({});
  const [raceID, setRaceID] = useState<number>(-1);
  const [getAccesToken, setAccesToken] = useState<string>("");
  const [usersTypes, setUsersTypes] = useState<UserTypes | null>(null);
  useEffect(() => {
    localStorage.setItem("saved_race_" + raceID, JSON.stringify({ blade: blades, visul: bladeVisuals }));
  }, [blades, bladeVisuals]);
  const getBlade = (id: number): ViewProp | null => {
    let selBlade: ViewProp | null = null;
    if (blades.some((existingBlade) => id === existingBlade.id)) {
      selBlade = blades.filter((o) => o.id === id)[0];
    }
    return selBlade;
  };
  const registrateRaceID = (raceid: number) => {
    setRaceID(raceid);
  };
  const existsBlade = (classid: number, ipos: number): number | null => {
    const res = blades.filter(o => o.classId === classid && o.ipos === ipos);
    if (res && res.length > 0) {
      return res[0].id;
    }
    return null;
  }
  const addBlade = (blade: ViewProp) => {
    if (blade.Vtype === ViewType.stage) {
      blade.heightprocent = "100%";
      blade.fullheight = true;
    }
    else if (bladesFullHeight.includes(blade.Vtype)) {
      blade.fullheight = true;
      blade.maximized = true;
      blade.heightprocent = "100%";
    }

    if (!blades.some((existingBlade) => existingBlade.id === blade.id)) {
      // if (blades.length > 0){
      //    blade.order = Math.max(...blades.map(o => o.order)) + 1;
      // }
      setBlades((prev) => [...prev, blade]);
    }
  };
  const addBlades = (blades: ViewProp[]) => {
    setBlades(blades);
    setBladeVisuals({});
    setBladeElementRefs([]);



  };
  const setClassIDIpos = (id: number, classid: number, ipos: number | null): void => {
    const blade = getBlade(id);
    if (!blade) {
      return;
    }
    const updatedBlade = {
      ...blade,
      classId: classid,
      ipos: ipos,
    }; // update the height property here
    setBlades((prev) => prev.map((b) => (b.id === id ? updatedBlade : b)));
  };

  const getNameBlade = (id: number): string => {
    let blad = blades.filter(o => o.id === id);
    if (blad.length > 0) {
      return blad[0].name;
    }
    return "";
  }
  const setNameBlade = (id: number, name: string) => {
    setBlades((prevBlades) => prevBlades.map(blade => {
      if (blade.id === id) {
        return {
          ...blade,
          name: name,
        };
      }
      return blade;
    }));
  }
  const getFocusedBlade = (id: number): boolean => {
    if (id < 0 || !blades) {
      return false;
    }
    return blades.filter(o => o.id === id)[0].focused;
  }

  const setHideHamburger = (id: number) => {
    setBlades((prevBlades) => prevBlades.map(blade => {
      if (blade.id === id) {
        return {
          ...blade,
          hideMenu: (blade.hideMenu === undefined ? false : !blade.hideMenu),
        };
      }
      return blade;
    }));
  }
  const getHideHamburger = (id: number): boolean => {
    if (id < 0 || !blades) {
      return false;
    }
    let hid = blades.filter(o => o.id === id)[0].hideMenu;
    if (hid === undefined)
    {
      return false;
    }
    return hid;
  }

  const setFocusedBlade = (id: number) => {
    setBlades((prevBlades) => prevBlades.map(blade => {
      if (blade.id === id) {
        return {
          ...blade,
          focused: true,
        };
      }
      else {
        return {
          ...blade,
          focused: false,
        };
      }
    }));
  }

  const getAutoIposBlade = (id: number): boolean => {
    // const res = blades.filter(o => o.id === id)[0].isAutoPosition
    return blades.filter(o => o.id === id)[0].isAutoPosition ? true : false;
  }
  const setAutoIposBlade = (id: number, auto: boolean) => {
    setBlades((prevBlades) => prevBlades.map(blade => {
      if (blade.id === id) {
        return {
          ...blade,
          focused: true,
        };
      }
      else {
        return {
          ...blade,
          focused: false,
        };
      }
    }));
  }

  const setUserType = (type: UserTypes | null): void => {
    localStorage.setItem("user_type", JSON.stringify(type));
    setUsersTypes(type);
  }
  const getUserType = (): UserTypes | null => {
    return usersTypes;
  }

  const removeBlade = (bladeID: number) => {
    let maxIndex = blades.indexOf(blades.filter(o => o.id === bladeID)[0]);
    if (blades.length > 1) {
      if (maxIndex === 0) {
        setFocusedBlade(blades[1].id);
      }
      else {
        setFocusedBlade(blades[maxIndex - 1].id);
      }
    }
    setBlades((prev) => {
      // Find the order of the blade to be removed
      const bladeToRemove = prev.find(blade => blade.id === bladeID);
      if (!bladeToRemove) {
        return prev; // Blade not found, return previous state
      }
      const { order: orderToRemove } = bladeToRemove;

      // Filter out the blade to be removed and decrement the order of blades with a higher order
      return prev.reduce((newBlades: ViewProp[], blade) => {
        if (blade.id === bladeID) {
          // Skip the blade to be removed
          return newBlades;
        }
        if (blade.order > orderToRemove) {
          // Decrement the order of blades that came after the removed blade
          newBlades.push({ ...blade, order: blade.order - 1 });
        } else {
          // Keep the order of blades that came before the removed blade
          newBlades.push(blade);
        }
        return newBlades;
      }, []);
    });

    // If you need to update related visual state, do it here with the proper dependency
    // setBladeVisuals((prev) => prev.filter((bladeVisual) => bladeVisual.ID !== bladeID));
  };

  const clearBlades = (all: boolean) => {
    setBlades([]);
    setBladeVisuals({});
    setBladeElementRefs([]);
  };
  const registerRef = (id: number, ref: any) => {
    setBladeElementRefs((prevRefs) => ({ ...prevRefs, [id]: ref }));
  };

  const changeBladesizeAll = (full: boolean) => {
    setBlades((prev) =>
      prev.map((b) => (
        {
          ...b,
          fullheight: bladesFullHeight.includes(b.Vtype) ? true : full,
          heightprocent: full || bladesFullHeight.includes(b.Vtype) ? "100%" : "50%",
        }))
    );
  };
  const maximizeAllBlade = (full: boolean) => {

    setBlades((prev) =>
      prev.map((b) => (
        {
          ...b,
          maximized: full || bladesFullHeight.includes(b.Vtype) ? true : false,
        }))
    );
  }
  const maximizeBlade = (id: number, full: boolean | null): void => {
    setBlades((prevBlades) => prevBlades.map(blade => {
      if (blade.id === id) {
        return {
          ...blade,
          maximized: full !== null ? full : !blade.maximized,
        };
      }
      return blade;
    }));
  }
  const getMaximizeBlade = (id: number): boolean => {
    let blads = blades.filter(o => o.id === id);
    if (blads.length > 0) {
      return blads[0].maximized;
    }
    return true;
  }


  const moveBlade = (id: number, left: boolean) => {
    const blade = getBlade(id);
    if (!blade) return;

    if (left) {
      if (blade.order === 1) return; // First in order
      swapOrders(blade, blade.order - 1);
      //organizeBlades();
    } else {
      const maxOrder = Math.max(...blades.map((o) => o.order));
      if (blade.order === maxOrder) return; // Max order
      swapOrders(blade, blade.order + 1);
      //organizeBlades();
    }
  };
  const heightBlade = (id: number, full: boolean | null) => {
    const blade = getBlade(id);
    if (!blade) {
      return;
    }
    const updatedHeight = !blade.fullheight ? "100%" : "50%";
    const updatedBlade = {
      ...blade,
      fullheight: !blade.fullheight,
      heightprocent: updatedHeight,
    }; // update the height property here
    setBlades((prev) => prev.map((b) => (b.id === id ? updatedBlade : b)));
  };
  const getHeightBlade = (id: number): boolean => {
    const blade = getBlade(id);
    if (!blade) {
      return false;
    }
    return blade.fullheight;
  }

  const swapOrders = (blade: ViewProp, targetOrder: number) => {
    const targetBlade = blades.find((b) => b.order === targetOrder);
    if (!targetBlade) return;

    const updatedBlades = blades.map((b) => {
      if (b.id === blade.id) return { ...b, order: targetOrder };
      if (b.id === targetBlade.id) return { ...b, order: blade.order };
      return b;
    });

    setBlades(updatedBlades.sort((a, b) => a.order - b.order));
  };

  const reorderBlades = () => {
    let ordering = 0;
    setBlades((prev) =>
      prev.sort(o => o.order).map((b) => {
        ordering += 1;
        return ({
          ...b,
          order: ordering,
        })
      })
    );
  }
  useEffect(() => {
    const debouncedOrganizeBlades = debounce(organizeBlades, 50); // Adjust the debounce delay as needed (e.g., 300 milliseconds).
    debouncedOrganizeBlades();
  }, [blades]);



  const organizeBlades = () => {
    // return;
    const newVisuals: Record<
      number,
      { marginLeft: string; marginTop: string }
    > = {};

    for (let i = 0; i < blades.length; i++) {
      const currentBlade = blades[i];

      if (i >= blades.length - 1) {
        newVisuals[currentBlade.id] = {
          marginLeft: "",
          marginTop: "0",
        };
        continue;
      }
      const nextBlade = blades[i + 1];
      const bladeElement = bladeElementRefs[currentBlade.id];
      const bladeElementNext = bladeElementRefs[nextBlade.id];

      if (bladeElement) {
      }
      if (bladeElementNext) {
        // bladeElementNext
      }

      if (!currentBlade.fullheight && nextBlade && !nextBlade.fullheight) {

        // console.log(bladeElement);
        if (bladeElement === undefined || bladeElement.getBoundingClientRect() === undefined) {
          return;
        }
        if (bladeElementNext === undefined || bladeElementNext.getBoundingClientRect() === undefined) {
          return;
        }
        let eleHeight: number =
          bladeElement.getBoundingClientRect().height >
            bladeElementNext.getBoundingClientRect().height
            ? bladeElementNext.getBoundingClientRect().height
            : bladeElement.getBoundingClientRect().height;

        const curWid: number = bladeElement.getBoundingClientRect().width;
        const nxtWid: number = bladeElementNext.getBoundingClientRect().width;
        let eleWid: number;
        if (curWid > nxtWid) {
          eleWid = nxtWid;
        } else {
          eleWid = curWid;
        }

        newVisuals[currentBlade.id] = {
          marginLeft: "",
          marginTop: "0",
        };
        newVisuals[nextBlade.id] = {
          marginLeft: eleWid * -1 + "px",
          marginTop: eleHeight + "px", // Assuming the app size is the window's height, adjust as necessary
        };
        i++;
      } else {
        newVisuals[currentBlade.id] = {
          marginLeft: "",
          marginTop: "0",
        };
      }
    }

    setBladeVisuals(newVisuals);
  };
  const setMobileMode = (isMobile: boolean) => {
    setIsMobileMode(isMobile);

  }
  const getMobileMode = (): boolean => {
    return isMobileMode;
  }

  return (
    <BladesContext.Provider
      value={{
        blades,
        addBlade,
        removeBlade,
        registrateRaceID,
        moveBlade,
        heightBlade,
        getHeightBlade,
        getBlade,
        maximizeAllBlade,
        bladeVisuals,
        maximizeBlade,
        getMaximizeBlade,
        clearBlades,
        registerRef,
        changeBladesizeAll,
        organizeBlades,
        setUserType,
        getUserType,
        getNameBlade,
        reorderBlades,
        setNameBlade,
        setClassIDIpos,
        setFocusedBlade,
        getFocusedBlade,
        getMobileMode,
        setMobileMode,
        addBlades,
        getAccesToken,
        setAccesToken,
        getAutoIposBlade,
        setAutoIposBlade,
        raceID,
        existsBlade,
        setHideHamburger,
        getHideHamburger
      }}
    >
      {children}
    </BladesContext.Provider>
  );
};

export const useBlade = (): BladeContextProps => {
  const context = useContext(BladesContext);
  if (!context) {
    throw new Error("useBlade must be used within a BladeProvider");
  }
  return context;
};

